import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-top: .5rem;
`;

export const StyledOptions = styled.h4`
  margin-bottom: 0;
`;
